interface EndPoint {
  url?: string;
  list?: string;
  add?: string;
  edit?: string;
  delete?: string;
  service?: string;
}

export const end_points = {
  login: {
    url: '/login',
  },
  register: {
    url: '/register',
  },
  logout: {
    url: '/logout',
  },
  search: {
    url: '/search',
  },
  productDetail: {
    url: '/product_details',
  },
  preFooter: {
    url: '/pre_footer',
  },
  forgotPassword: {
    url: '/forgot-password',
  },
  address: {
    url: '/address',
    add_address: '/create-address',
    update_address: '/update-address',
    delete_addres: '/delete-address',
  },
  myReferrals: {
    url: '/my-referrals',
  },
  placeOrder: {
    url: '/place_order',
  },
  headers: {
    url: '/headers',
  },
  checkout: {
    url: '/checkout',
  },
  createSetupIntent: {
    url: '/create_setup_intent',
  },
  listSavedCards: {
    url: '/list_saved_cards',
  },
  getDeliveryDates: {
    url: '/get_delivery_dates',
  },
  chats: {
    url: '/chats',
  },
  sendMessage: {
    url: '/send_message',
  },
  tableBooking: {
    url: '/table_booking',
  },
  bookTable: {
    url: '/book_table_request',
  },
  expressWash: {
    url: '/calculate_express_wash',
  },
  calculateDeliveryCharge: {
    url: '/calculate_delivery_charge',
  },
};
